import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';

interface FormContainerProps {
     children: React.ReactNode;
     sx?: SxProps<Theme>;
}

const FormContainer: React.FC<FormContainerProps> = ({ children, sx }) => {
     return (
          <Box
               sx={[
                    (theme) => ({
                         width: '100%',
                         maxWidth: 400,
                         background: theme.palette.mode === 'dark' ? 'rgba(20,22,34,0.72)' : 'rgba(255,255,255,0.13)',
                         borderRadius: 2,
                         boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
                         p: 4,
                         m: '0 auto',
                         display: 'flex',
                         flexDirection: 'column',
                         alignItems: 'center',
                         backdropFilter: 'blur(2.5px)',
                         transition: 'background 0.5s',
                    }),
                    ...(Array.isArray(sx) ? sx : [sx]),
               ]}
          >
               {children}
          </Box>
     );
};

export default FormContainer;
